import createAxios from "./axiosHttp";

function getZones(pagination, query, sort) {
  const axios = createAxios();
  const urlPath = "ttmm/zone/ql";
  return axios.post(urlPath, { pagination, query, sort });
}

function exportar(pagination, query, sort) {
  const axios = createAxios();
  const urlPath = "ttmm/zone/ql/export";
  return axios.post(
    urlPath,
    { pagination, query, sort },
    { responseType: "arraybuffer" }
  );
}

function getZoneById(zone_id) {
  const axios = createAxios();
  const urlPath = `ttmm/zone/${zone_id}`;
  return axios.get(urlPath);
}

function createZone(body) {
  const axios = createAxios();
  const urlPath = "ttmm/zone";
  return axios.post(urlPath, body);
}

function updateZone(body, zone_id) {
  const axios = createAxios();
  const urlPath = `ttmm/zone/${zone_id}`;
  return axios.put(urlPath, body);
}

function deleteZone(zone_ids) {
  const axios = createAxios();
  const urlPath = `ttmm/zone/${zone_ids}`;
  return axios.delete(urlPath);
}

export const zoneService = {
  getZones,
  exportar,
  getZoneById,
  createZone,
  updateZone,
  deleteZone,
};
